import axios from 'axios';
import { setMockClientStatus } from 'utils/mock-client';
import { isOfflineMockEnabled } from './flag';
import { handleGraphql } from './graphql';
import { handleRest } from './rest';

function jsonResponse(data: unknown, status = 200) {
  return new Response(JSON.stringify(data), {
    status,
    headers: { 'Content-Type': 'application/json' },
  });
}

function parseGraphqlBody(init?: RequestInit): { query: string; variables: Record<string, unknown> } {
  if (!init?.body || typeof init.body !== 'string') {
    return { query: '', variables: {} };
  }
  try {
    const parsed = JSON.parse(init.body);
    return { query: String(parsed.query || ''), variables: parsed.variables || {} };
  } catch {
    return { query: '', variables: {} };
  }
}

export function installOfflineMock() {
  if (!isOfflineMockEnabled()) {
    return;
  }

  // Офлайн-режим подразумевает и эмуляцию подписи: иначе вход по сертификату
  // бесконечно опрашивает локальные службы ViPNet/JaCarta и показывает баннер
  // «установите PKI-клиент» вместо списка сертификатов.
  setMockClientStatus(true);

  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = new URL(
      typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.toString()
          : input.url,
      window.location.origin,
    );

    if (url.pathname.includes('/graphql') || url.href.includes('/graphql')) {
      const { query, variables } = parseGraphqlBody(init);
      const data = handleGraphql(query, variables);
      return jsonResponse({ data });
    }

    const rest = handleRest(url, init);
    if (rest) {
      return rest;
    }

    if (url.hostname.includes('contracteum.com') || url.hostname.includes('mock.local')) {
      return jsonResponse({ data: [], items: [], list: [] });
    }

    return nativeFetch(input, init);
  };

  axios.interceptors.request.use((config) => {
    const url = config.url || '';
    if (!url.includes('contracteum.com') && !url.includes('mock.local') && !url.includes('/graphql')) {
      return config;
    }

    config.adapter = async () => ({
      data: { data: [ { id: 'w-1', statusId: 'draft' } ], items: [] },
      status: 200,
      statusText: 'OK',
      headers: {},
      config,
    });
    return config;
  });

  // eslint-disable-next-line no-console
  console.info(
    '[offline-mock] interceptors installed (stateful; reset: localStorage.removeItem("offline-mock-state"))',
  );
}
